module.exports = __webpack_public_path__ + "static/media/video_play_icon_big.78345e2b.svg";